// extracted by mini-css-extract-plugin
export default {"horizontalDiv":"Information_horizontalDiv__ivf6I"};